/**
 * @description Safely converts a string to lowercase, handling null or undefined values defaulting to an empty string.
 * @param input - The input string to be converted to lowercase.
 * @example
 * ```ts
 * import { safeToLowerCase } from '@abg/web-core';
 * const result = safeToLowerCase('Hello World');
 * console.log(result); // Output: 'hello world'
 * ```
 * @example
 * ```ts
 * import { safeToLowerCase } from '@abg/web-core';
 * const result = safeToLowerCase(null);
 * console.log(result); // Output: ''
 * ```
 * @example
 * ```ts
 * import { safeToLowerCase } from '@abg/web-core';
 * const result = safeToLowerCase(undefined);
 * console.log(result); // Output: ''
 * ```
 * @returns string
 */
export const safeToLowerCase = (input: string | null | undefined): string =>
  input?.toLowerCase() ?? '';
